import { motion } from "motion/react";

type Props = {
  title: string;
  subtitle?: string;
  description?: string;
  accentBgClass?: string; // optional to vary background per category
};

export default function ProductHero({
  title,
  subtitle,
  description,
  accentBgClass = "bg-hero dark:bg-midnight",
}: Props) {
  return (
    <section className={`relative pt-40 pb-20 px-6 ${accentBgClass} overflow-hidden`}>
      <div className="absolute top-0 right-0 w-[30rem] h-[30rem] bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />

      <div className="max-w-[83.75rem] mx-auto text-center relative z-10">
        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="text-48 md:text-6xl font-bold mb-6"
        >
          {title.split(" ").slice(0, 1)}{" "}
          <span className="text-primary">{title.split(" ").slice(1).join(" ")}</span>
        </motion.h1>

        {description ? (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.12 }}
            className="text-lg md:text-xl text-muted dark:text-white/70 max-w-3xl mx-auto"
          >
            {description}
          </motion.p>
        ) : (
          subtitle && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.12 }}
              className="text-lg md:text-xl text-muted dark:text-white/70 max-w-3xl mx-auto"
            >
              {subtitle}
            </motion.p>
          )
        )}
      </div>
    </section>
  );
}
